import React, { Component } from 'react';
import resources from '../resources';

class Footer extends Component {
  scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  openLink = (url) => {
    window.open(url, '_blank');
  };

  render() {
    return (
      <div style={{
        backgroundColor: '#fff',
        borderTop: '1px solid #eee',
        padding: '40px 24px',
        position: 'relative',
      }}>
        <div style={{
          maxWidth: 1040,
          margin: '0 auto',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 24,
        }}>
          {/* Logo */}
          <img
            src={resources.images.Footer_logo}
            alt="VNG Logo"
            style={{ height: 32 }}
          />

          {/* Social icons */}
          <div style={{ display: 'flex', gap: 16 }}>
            <img
              src={resources.icons.Footer_iconweb}
              alt="Website"
              style={{ width: 20, height: 20, cursor: 'pointer' }}
              onClick={() => this.openLink('https://vng.com.vn/')}
            />
            <img
              src={resources.icons.Footer_iconfacebook}
              alt="Facebook"
              style={{ width: 20, height: 20, cursor: 'pointer' }}
              onClick={() => this.openLink('https://www.facebook.com/VNGCorporation.Official')}
            />
            <img
              src={resources.icons.Footer_iconlinkin}
              alt="LinkedIn"
              style={{ width: 20, height: 20, cursor: 'pointer' }}
              onClick={() => this.openLink('https://www.linkedin.com/company/vng-corporation/posts/?feedView=all')}
            />
          </div>

          {/* Copyright */}
          <div style={{ fontSize: 16, color: '#555' }}>
            ©2025 VNG Copyright
          </div>
        </div>

        {/* Scroll to top button */}
        <div
          onClick={this.scrollToTop}
          style={{
            position: 'absolute',
            right: 24,
            top: -20,
            width: 40,
            height: 40,
            borderRadius: '50%',
            backgroundColor: '#111',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          }}
        >
          <img
            src={resources.icons.Footer_iconscrolltop}
            alt="Scroll to top"
            style={{ width: 40, height: 40 }}
          />
        </div>
      </div>
    );
  }
}

export default Footer;
